import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import forEachRight from 'lodash/forEachRight';
import { Breadcrumb, Row, Card, Skeleton, Button } from 'antd';

import OneRowData from 'components/OneRowData';

import { formatDateTimeDetail, formatMoney } from 'shared/utils/StringUtil';
import { ORDER_STATUS } from '../../constant/DeliveryDefaultVar';
import { getColorStatus } from '../../utils/FilesUtil';
import deliveryRoute from '../../route';

import text from './OrderDetail.page.translation';
import './OrderDetail.style.less';

export class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: this.props.match.params.id || '',
    };
  }

  componentDidMount() {
    if (this.state.orderId) {
      this.props.getSingleOrder(this.state.orderId);
      this.props.getSingleOrderStatus(this.state.orderId);
    }
  }

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={deliveryRoute.ORDER_LIST}>
              {formatMessage(text.breadCrumbOrderList)}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {formatMessage(text.breadCrumbOrderDetail)}
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );
  };

  renderrowData = (data, key) => <OneRowData key={key} data={data[key]} />;

  getOrderDetailInfoLeft = (dataDetail, trackStatus) => {
    const {
      intl: { formatMessage },
    } = this.props;

    const orderId = get(dataDetail, 'id', '-');
    const danaUser = get(dataDetail, 'dana_public_id', '-');
    const senderName = get(dataDetail, 'sender_details.fullname', '-');
    const senderLocation = get(
      dataDetail,
      'sender_details.address_street',
      '-',
    );
    const phoneNumber = get(dataDetail, 'sender_details.phone_number', '-');

    const getInfoTrack = this.getStatusFromTrackHistory(trackStatus);

    const newStatus = this.convertEnumStatus(getInfoTrack.status);

    const setDetailInfoLeft = [
      {
        label: formatMessage(text.form.label.orderId),
        value: orderId,
      },
      {
        label: formatMessage(text.form.label.danaUser),
        value: danaUser,
      },
      {
        label: formatMessage(text.form.label.senderName),
        value: senderName,
      },
      {
        label: formatMessage(text.form.label.senderLocation),
        value: senderLocation,
      },
      {
        label: formatMessage(text.form.label.phoneNumber),
        value: phoneNumber,
      },
      {
        label: formatMessage(text.form.label.dateTime),
        value: getInfoTrack.dateTime,
      },
      {
        label: formatMessage(text.form.label.status),
        value: newStatus.status,
        valueCustomClass: `value ${newStatus.statusCSS}`,
      },
    ];

    const setRowData = Object.keys(setDetailInfoLeft).map(
      this.renderrowData.bind(this, setDetailInfoLeft),
    );

    return setRowData;
  };

  getStatusFromTrackHistory = trackStatus => {
    const getLastIndex = trackStatus.length - 1;
    const getStatus = get(trackStatus[getLastIndex], 'internal_status', '-');
    const getDateTime = get(trackStatus[getLastIndex], 'created_at', '');

    let dateTime = '-';
    if (getStatus === ORDER_STATUS.PACKAGE_ARRIVED && getDateTime) {
      dateTime = formatDateTimeDetail(getDateTime);
    }

    const result = {
      status: getStatus,
      dateTime,
    };

    return result;
  };

  convertEnumStatus = status => {
    const {
      intl: { formatMessage },
    } = this.props;

    const newStatus = {
      status: '',
    };

    if (status !== '-') {
      newStatus.status = formatMessage({
        id: `orderStatus.${status.toLowerCase()}`,
      });
    }

    newStatus.statusCSS = getColorStatus(status);

    return newStatus;
  };

  stringChecker = value => {
    if (!value) {
      return '-';
    }
    return value;
  };

  getOrderDetailInfoRight = dataDetail => {
    const {
      intl: { formatMessage },
    } = this.props;

    const recipientName = get(dataDetail, 'recipient_details.fullname', '-');
    const recipientLocation = get(
      dataDetail,
      'recipient_details.address_street',
      '-',
    );

    let courierBy = get(dataDetail, 'carrier_details.courier_name', '-');
    courierBy = this.stringChecker(courierBy);

    const serviceType = get(dataDetail, 'carrier_details.service_type', '-');
    const awb =
      get(dataDetail, 'carrier_details.partner_name', '').toLowerCase() ===
      'anteraja'
        ? get(dataDetail, 'partner_delivery_id')
        : '-';
    const itemCategory = get(dataDetail, 'package_details.package_type', '-');

    const getDriverInfo = get(dataDetail, 'carrier_details.driver_name', '-');
    const driverInfo = this.splitDriverInfo(getDriverInfo);

    const totalPayment = formatMoney(get(dataDetail, 'amount_total', '0'));

    const source = get(dataDetail, 'client_name', '-');

    const setDetailInfoRight = [
      {
        label: formatMessage(text.form.label.recipientName),
        value: recipientName,
      },
      {
        label: formatMessage(text.form.label.recipientLocation),
        value: recipientLocation,
      },
      {
        label: formatMessage(text.form.label.source),
        value: source,
      },
      {
        label: formatMessage(text.form.label.courierBy),
        value: courierBy,
      },
      {
        label: formatMessage(text.form.label.serviceType),
        value: serviceType,
      },
      {
        label: formatMessage(text.form.label.awb),
        value: awb,
      },
      {
        label: formatMessage(text.form.label.itemCategory),
        value: itemCategory,
      },
      {
        label: formatMessage(text.form.label.driverName),
        value: driverInfo.driverName,
      },
      {
        label: formatMessage(text.form.label.vehicleNumber),
        value: driverInfo.vehicleNumber,
      },
      {
        label: formatMessage(text.form.label.totalPayment),
        value: totalPayment,
      },
    ];

    const setRowData = Object.keys(setDetailInfoRight).map(
      this.renderrowData.bind(this, setDetailInfoRight),
    );

    return setRowData;
  };

  splitDriverInfo = driverInfo => {
    const splitInfo = driverInfo.split('-');

    const splitDriver = {
      driverName: '-',
      vehicleNumber: '-',
    };

    if (splitInfo[0]) {
      const sampleDriverName = splitInfo[0];
      splitDriver.driverName = sampleDriverName;
    }

    if (splitInfo[1]) {
      const sampleVehicleNumber = splitInfo[1];
      splitDriver.vehicleNumber = sampleVehicleNumber;
    }
    return splitDriver;
  };

  renderOrderDetailInfo = () => {
    const {
      intl: { formatMessage },
      orderDetail,
      orderTrackStatus,
      loading,
    } = this.props;
    const dataDetail = get(orderDetail, 'payload', {});
    const getTrackStatus = get(orderTrackStatus, 'payload', {});
    return (
      <Card title={formatMessage(text.detailTitle)}>
        <Row type="flex">
          <Card.Grid>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 7, width: ['100%', '100%'] }}
              title={false}
            >
              {this.getOrderDetailInfoLeft(dataDetail, getTrackStatus)}
            </Skeleton>
          </Card.Grid>
          <Card.Grid>
            <Skeleton
              loading={loading}
              active
              paragraph={{ rows: 7, width: ['100%', '100%'] }}
              title={false}
            >
              {this.getOrderDetailInfoRight(dataDetail)}
            </Skeleton>
          </Card.Grid>
        </Row>
      </Card>
    );
  };

  renderMapRoute = () => {
    const {
      intl: { formatMessage },
      orderDetail,
    } = this.props;
    const trackUrl = get(orderDetail, 'payload.carrier_details.track_URL', '');
    const getImageMap = get(orderDetail, 'payload.static_map_url', '');
    return (
      <Card title={formatMessage(text.mapRouteTitle)}>
        <Row type="flex">
          <div className="map-route-wrapper">
            <img src={getImageMap} alt="map-route" />
          </div>
        </Row>
        {trackUrl.length > 0 && (
          <Button
            type="primary"
            style={{ margin: 25, marginTop: 0 }}
            onClick={() => {
              window.open(trackUrl, '_blank');
            }}
          >
            Track URL
          </Button>
        )}
      </Card>
    );
  };

  setOrderTrackStatusContent = (data, index, getTotalData) => {
    let cssBold = '';
    if (index === getTotalData) {
      cssBold = 'bold';
    }

    let cssColorBullet = 'custom-bullet ';
    const getConvertStatus = this.convertEnumStatus(data.internal_status);

    cssColorBullet += getConvertStatus.statusCSS;

    const convertDateTime = formatDateTimeDetail(data.created_at);

    const remarks = get(data, 'remarks', '');
    const cssRemarks = `${cssBold} remarks-span`;

    const orderTrackingBoxCss = remarks
      ? 'order-tracking-box remarks'
      : 'order-tracking-box';

    return (
      <div key={index} className={orderTrackingBoxCss}>
        <div className="order-tracking-content">
          <div className={cssColorBullet}></div>
          <span className={cssBold}>{getConvertStatus.status}</span>
          <span className={cssBold}>{convertDateTime} WIB</span>
          {remarks && <span className={cssRemarks}>{remarks}</span>}
        </div>
      </div>
    );
  };

  renderOrderTracking = () => {
    const {
      intl: { formatMessage },
      orderTrackStatus,
    } = this.props;

    const getTrackStatus = get(orderTrackStatus, 'payload', []);
    const getTotalData = getTrackStatus.length - 1;
    const resultContent = [];

    forEachRight(getTrackStatus, (data, index) => {
      resultContent.push(
        this.setOrderTrackStatusContent(data, index, getTotalData),
      );
    });

    return (
      <Card title={formatMessage(text.orderTrackingTitle)}>
        <Row type="flex">
          <div className="order-tracking-wrapper">{resultContent}</div>
        </Row>
      </Card>
    );
  };

  _handleBackStep = () => {
    this.props.history.goBack();
  };

  renderBackBtn = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Button
        type="primary"
        className="btn back-btn mtop0"
        onClick={this._handleBackStep}
      >
        {formatMessage(text.btn.backBtn)}
      </Button>
    );
  };

  render() {
    return (
      <div className="main-content order-detail-main-wrapper">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          {this.renderOrderDetailInfo()}
          {this.renderMapRoute()}
          {this.renderOrderTracking()}

          {this.renderBackBtn()}
        </div>
      </div>
    );
  }
}

OrderDetail.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object,
  orderDetail: PropTypes.object,
  orderTrackStatus: PropTypes.object,
  match: PropTypes.object,
  loading: PropTypes.bool,
  getSingleOrder: PropTypes.func,
  getSingleOrderStatus: PropTypes.func,
};

export default OrderDetail;
